import {useAuthState} from "react-firebase-hooks/auth";
import {auth} from "../firebase";

export default function useSessionPersist() {
	const [user, userLoading, ...rest] = useAuthState(auth);
	return [user,userLoading, ...rest];
}
